import type { ConfluenceEndUserRequestAnalyticsAttributes } from '@atlassian/confluence-end-user-upgrade-request-modal';

import type { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { mapConfluenceEditionToSupportedCurrentEdition } from '../utils/mapConfluenceEditionToSupportedCurrentEdition.ts';

// Ensures consistency in the edition attribute name and value
export const editionAnalytics = (
	edition: ConfluenceEdition | null,
): Partial<Pick<ConfluenceEndUserRequestAnalyticsAttributes, 'currentProductEdition'>> => ({
	currentProductEdition: mapConfluenceEditionToSupportedCurrentEdition(edition),
});
